import { z } from "zod";

export const TRACE_KINDS = [
  "received",
  "parsed",
  "screened",
  "routed",
  "input",
  "policy",
  "approved",
  "rejected",
  "overridden",
  "resolved",
  "wrote",
  "delivered",
  "sent",
  "bounce",
  "replayed",
  "done",
  "followUp",
] as const;
export type TraceKind = (typeof TRACE_KINDS)[number];

/** Detail that the tenant may see. Values are plain JSON. */
export const publicDetailSchema = z.record(z.string(), z.json());
export type PublicDetail = z.infer<typeof publicDetailSchema>;

/** The public shape of one trace step. Operator-only detail is stored beside it and never returned. */
export const traceStepSchema = z.strictObject({
  seq: z.int().min(1),
  at: z.iso.datetime(),
  kind: z.enum(TRACE_KINDS),
  text: z.string().max(500),
  publicDetail: publicDetailSchema.optional(),
});
export type TraceStep = z.infer<typeof traceStepSchema>;
